import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=f351916e&"
import script from "./DetailModal.vue?vue&type=script&lang=ts&"
export * from "./DetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports